import React, { useState, useEffect } from 'react';
import api from '../utils/api';

// Продажи готовых документов с сайта ucfemida.ru (ЮKassa). Отметка «чек пробит» закрывает задачу «Продажа на сайте». 19.10.2026
const STATUS = {
  paid: ['Оплачен', 'var(--green, #16a34a)'],
  pending: ['Ждёт оплаты', 'var(--text-muted)'],
  canceled: ['Не оплачен', 'var(--text-muted)'],
  refunded: ['Возврат', 'var(--red)'],
};
const rub = n => Number(n || 0).toLocaleString('ru-RU') + ' ₽';
const dt = s => s ? new Date(s).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

export default function ShopOrdersPage() {
  const [list, setList] = useState([]);
  const [all, setAll] = useState(false);

  const load = () => api.get('/shop-orders').then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const receipt = async (o, done) => { await api.patch(`/shop-orders/${o.id}/receipt`, { done }); load(); };

  const real = list.filter(o => !o.test);
  const paid = real.filter(o => o.status === 'paid');
  const month = new Date().toISOString().slice(0, 7);
  const paidMonth = paid.filter(o => (o.paid_at || '').slice(0, 7) === month);
  const noReceipt = paid.filter(o => !o.receipt_done);
  const shown = all ? list : list.filter(o => o.status === 'paid' || o.status === 'refunded');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Продажи с сайта</h1>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Готовые документы на <a href="https://ucfemida.ru/gotovye-dokumenty/" target="_blank" rel="noopener noreferrer">ucfemida.ru/gotovye-dokumenty</a>, оплата через ЮKassa</div>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
        <div className="card" style={{ flex: '1 1 160px' }}><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>За этот месяц</div><div style={{ fontSize: 20, fontWeight: 700 }}>{rub(paidMonth.reduce((s, o) => s + o.amount, 0))}</div><div style={{ fontSize: 12 }}>{paidMonth.length} продаж</div></div>
        <div className="card" style={{ flex: '1 1 160px' }}><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Всего</div><div style={{ fontSize: 20, fontWeight: 700 }}>{rub(paid.reduce((s, o) => s + o.amount, 0))}</div><div style={{ fontSize: 12 }}>{paid.length} продаж</div></div>
        <div className="card" style={{ flex: '1 1 160px', borderColor: noReceipt.length ? 'var(--red)' : undefined }}><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Чек не пробит</div><div style={{ fontSize: 20, fontWeight: 700, color: noReceipt.length ? 'var(--red)' : undefined }}>{noReceipt.length}</div><div style={{ fontSize: 12 }}>{noReceipt.length ? 'пробейте в «Мой налог»' : 'всё в порядке'}</div></div>
      </div>

      <label style={{ display: 'inline-flex', gap: 6, alignItems: 'center', fontSize: 13, marginBottom: 10, cursor: 'pointer' }}>
        <input type="checkbox" checked={all} onChange={e => setAll(e.target.checked)} /> показать и неоплаченные попытки
      </label>

      <div className="card">
        <div className="table-wrap"><table>
          <thead><tr><th>Дата</th><th>Документ</th><th>Сумма</th><th>Покупатель</th><th>Статус</th><th>Скачано</th><th>Чек</th></tr></thead>
          <tbody>
            {shown.map(o => {
              const [st, color] = STATUS[o.status] || [o.status, 'inherit'];
              return (
                <tr key={o.id} style={{ opacity: o.test ? 0.55 : 1 }}>
                  <td style={{ whiteSpace: 'nowrap' }}>{dt(o.paid_at || o.created_at)}</td>
                  <td>{o.title}{o.test && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}> · тест</span>}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{rub(o.amount)}</td>
                  <td style={{ fontSize: 13 }}><a href={`mailto:${o.email}`}>{o.email}</a></td>
                  <td style={{ color, fontWeight: 600, whiteSpace: 'nowrap' }}>{st}</td>
                  <td>{o.downloads}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {o.status !== 'paid' ? '—' : o.receipt_done
                      ? <span title={dt(o.receipt_at)}>✓ пробит <button className="btn btn-secondary btn-sm" onClick={() => receipt(o, false)}>отменить</button></span>
                      : <button className="btn btn-primary btn-sm" onClick={() => receipt(o, true)}>Чек пробит</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table></div>
        {!shown.length && <div className="empty-state"><p>Продаж пока нет</p></div>}
      </div>
    </div>
  );
}
